import "./StarRating.css";

const StarRating = ({ rating = 0, count, size = "md", showCount = true }) => {
  const value = Math.max(0, Math.min(5, Number(rating) || 0));
  const fullStars = Math.floor(value);
  const hasHalf = value - fullStars >= 0.25 && value - fullStars < 0.75;
  const roundUp = value - fullStars >= 0.75;

  const stars = [];
  for (let i = 0; i < 5; i += 1) {
    if (i < fullStars || (roundUp && i === fullStars)) {
      stars.push("full");
    } else if (hasHalf && i === fullStars) {
      stars.push("half");
    } else {
      stars.push("empty");
    }
  }

  return (
    <div className={`star-rating star-rating--${size}`} aria-label={`${value.toFixed(1)} out of 5 stars`}>
      <span className="star-rating__stars" aria-hidden="true">
        {stars.map((type, index) => (
          <span key={index} className={`star-rating__star star-rating__star--${type}`}>
            ★
          </span>
        ))}
      </span>
      {showCount && (
        <span className="star-rating__meta">
          {value > 0 ? value.toFixed(1) : "0.0"}
          {typeof count === "number" ? ` (${count})` : ""}
        </span>
      )}
    </div>
  );
};

export default StarRating;
